import { useMutation, useQuery } from "@tanstack/react-query";
import queryKey from "../../../enumerations/queryKey";
import { getSetting } from "../../../hooks/service";
import { apiGetAgentWallet, apiGetUserInfo, apiPostFileManager, apiPutWithdraw } from "../service";

export const useGetUserInfo = (options) => {
  return useQuery([queryKey.USER_INFO], () => apiGetUserInfo().then((res) => res.data.data), {
    ...options,
  });
};

export const useGetCSLink = ({ options, userCurrency }) => {
  return useQuery(
    [queryKey.CS_LINK],
    () =>
      getSetting({ userCurrency: userCurrency }).then((res) => {
        const data = res.data.data;
        if (data && data?.length > 0) {
          const csData = JSON.parse(data[0]?.value);
          if (csData?.status == 1) {
            return csData.cs_url;
          } else {
            return null;
          }
        } else {
          return null;
        }
      }),
    {
      ...options,
    },
  );
};

export const useGetNowTimezone = (options) => {
  return useQuery(
    [queryKey.NOW_TIMEZONE],
    () => apiGetAgentWallet({}).then((res) => res.data.result),
    {
      ...options,
    },
  );
};

export const useGetAgentBalance = (params, options) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useQuery(
    [queryKey.AGENT_BALANCE, ..._arrParams],
    () => apiGetAgentWallet(params).then((res) => res.data.data),
    {
      ...options,
    },
  );
};

//export
export const usePostFileManager = (options) => {
  return useMutation(
    (params) => apiPostFileManager({ ...params, source: 1 }).then((res) => res.data.data),
    {
      ...options,
    },
  );
};

//transfer
export const usePutWithdraw = (options) => {
  return useMutation((params) => apiPutWithdraw(params).then((res) => res.data.data), {
    ...options,
  });
};
